import axios from 'axios';
import { loginreq, req } from './axiosFun';
import { downLoadReq }  from "./downLoad"
// 登录接口
//https://s.js-5.com/api/user/login
export const login = (params) => { return loginreq("post", "/api/login/loginUser", params) };
// 获取用户菜单
export const menu = (params) => { return req("get","/api/userInfo/getSysPermissionListByUid" ,params) };
// 退出接口
// export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// export const loginout = () => { return axios.post("/api/login/logOut").then(res => res.data) };

export const loginout = (params) => { return req("post", "/api/login/logOut", params) };
/**
 * 用户管理
 **/



// 用户管理-获取用户列表
export const userList = (params) => { return req("get", "/api/userInfo/userInfoList", params) };
// 用户管理-（添加）
export const userAdd = (params) => { return req("post", "/api/userInfo/userInfoAdd", params) };


// 用户管理-（更新）
export const userUpdate = (params) => { return req("post", "/api/userInfo/updateUserInfo", params) };
// 用户管理-分配角色
export const userRoleSave = (params) => { return req("post", "/api/userInfo/saveRoleId", params) };

// 用户管理-批量分配角色
export const saveRoleIdBatch = (params) => { return req("post", "/api/userInfo/saveRoleIdBatch", params) };

// 用户管理-删除用户
export const userDelete = (params) => { return req("post", "/api/userInfo/deleteUserInfo", params) };
// 用户管理-获取所有角色
export const userRoleList = (params) => { return req("get", "/api/sysRole/sysRoleListAll" + params, {}) };
// 用户管理-修改密码
export const passwordUpdate = (params) => { return req("post", "/api/userInfo/updatePassword" ,params) };

// 用户管理-用户分配部门
export const setDept = (params) => { return req("post", "/api/userInfo/setUserInfoDepartment", params) };

// 用户管理-用户批量分配部门
export const setBtchDept = (params) => { return req("post", "/api/department/departmentAddUserInfo", params) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("get", "/api/sysPermission/sysPermissionList") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/api/Module/nodes", params) };
// 菜单管理-增加菜单
export const MenuSave = (params) => { return req("post", "/api/sysPermission/sysPermissionAdd", params) };
// 菜单管理-修改菜单
export const MenuUpDate = (params) => { return req("post", "/api/sysPermission/sysPermissionUpdate", params) };

// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return req("post","/api/sysPermission/sysPermissionDelete",params)};

/**
 * 角色管理
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return req("get", "/api/sysRole/sysRoleList", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", "/api/sysRole/sysRoleListAdd", params) };

// 角色管理-编辑
export const roleUpdate = (params) => { return req("post", "/api/sysRole/sysRoleUpdate", params) };

// 角色管理-删除角色
export const roleDelete = (params) => { return req("post","/api/sysRole/sysRoleListDelete" ,params ) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return req("post", "/api/sysRole/getPermissionByRoleId" , params ) };


// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/sysRole/savePermissionId", params) };

/**
 * 公司管理
 **/
// 公司管理-获取公司列表
export const deptList = (params) => { return req("get", "/api/department/departmentListByAddRole", params) };


//公司管理，根据登录用户获取一级部门
export const deptListFirst = (params) => { return req("get", "/api/department/getFirstDepartmentByAddDep", params) };



export const departmentList = (params) => { return req("get", "/api/department/departmentListByAddRole", params) };

// 公司管理-保存（添加编辑）
export const departmentAdd = (params) => { return req("post", "/api/department/departmentAdd", params) };

// 公司管理-修改（添加编辑）
export const departmentUpdate = (params) => { return req("post", "/api/department/departmentUpdate", params) };



// 公司管理-删除公司
export const deptDelete = (params) =>  { return req("post", "/api/department/deleteDepartment", params) };

// 根据部门获取用户
export const getUserByDeptId = (params) => { return req("get", "/api/department/getAllDepartmentUserInfoList", params) };

// 设置管理员
export const setAdminMG = (params) => { return req("post", "/api/department/departmentAddAdmin", params) };



/**
 * 房间管理
 */
//房间管理添加
export const roomAdd = (params) => { return req("post", "/api/room/roomAdd", params) };

//房间管理添加
export const roomList = (params) => { return req("get", "/api/room/roomList", params) };

//房间管理修改
export const roomUpdate = (params) => { return req("post", "/api/room/roomUpdate", params) };

//房间管理删除
export const roomDelete = (params) => { return req("post", "/api/room/roomDelete", params) };

//导入房间
export const uploadRoom = (params) => { return req("post", "/api/room/uploadRoomList", params,true) };


// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };


// 获取操作记录
export const findSysLogList = (params) => { return req("get", "/api/sysLog/findSysLogList", params) };

// 月账单
// export const getMonthlyBillList = (params) => { return req("get", "/api/monthlyBill/getMonthlyBillList", params) };
export const getMonthlyBillList = (params) => { return req("get", "/api/newMonthBillData/getMonthlyBillList", params) };


// 生成月账单generateMonthlyBill
export const generateMonthlyBill = (params) => { return req("get", "/api/monthlyBill/generateMonthlyBill", params) };

// 生成月账单数据
export const generateESPowerData = (params) => { return req("get", "/api/manual/generateESPowerData", params) };


// 账单下载数据
export const downloadMonthlyBill = (params) => { return downLoadReq("get", "/api/monthlyBill/downloadMonthlyBill", params) };


export const exportMonthData = (params) => { return downLoadReq("get", "/api/newMonthBillData/exportMonthData", params) };




// 计算账单 3.23
export const calMeterInfoPrice = (params) => { return downLoadReq("get", "/api/manual/calMeterInfoPrice", params) };



// 权限管理-配置权限
export const updateUserInfoPassword = (params) => { return req("post", "/api/userInfo/updateUserInfoPassword", params) };


// 开户
export const addMeterInfoAppletUser = (params) => { return req("post", "/api/appletUser/addMeterInfoAppletUser", params) };


//开户删除
export const deleMeterInfoAppletUser = (params) => { return req("post", "/api/appletUser/deleMeterInfoAppletUser", params) };


//开户导出
export const poiOpenAccountList = (params) => { return downLoadReq("get", "/api/appletUser/poiOpenAccountList", params) };


// 获取所有的签名
export const getAllMsgSign = (params) => { return req("get", "/api/msg/getAllMsgSign", params) };

// 获取所有的模板
export const getAllMsgTemplate = (params) => { return req("get", "/api/msg/getAllMsgTemplate", params) };

// 获取短信配置
export const getMsgConfig = (params) => { return req("get", "/api/msg/getMsgConfig", params) };

// 保存短信配置
export const saveMsgConfig = (params) => { return req("post", "/api/msg/saveMsgConfig", params) };


// 开启关闭短信配置
export const openOrCloseSendMsg = (params) => { return req("post", "/api/department/openOrCloseSendMsg", params) };


// 添加微信支付配置文件信息
export const saveWXInfo = (params) => { return req("post", "/api/wxinfo/saveWXInfo", params) };

// 修改微信支付配置文件信息
export const updateWXInfo = (params) => { return req("post", "/api/wxinfo/updateWXInfo", params) };


// 查看微信支付配置文件信息
export const findWxInfo = (params) => { return req("get", "/api/wxinfo/findWxInfo", params) };

// 删除微信支付配置文件信息
export const deleteWxInfo = (params) => { return req("post", "/api/wxinfo/deleteWxInfo", params) };

//初始化底度数据
export const initData = (params) => { return req("post", "/api/manual/initData", params,true) };


export const getMsgDetailList = (params) => { return req("get", "/api/msg/getMsgDetailList", params,true) };

export const getMsgType = (params) => { return req("get", "/api/msg/getMsgType", params,true) };

export const uploadFile = (params) => { return req("post", "/api/upload/uploadFile", params,true) };

export const uploadSeal = (params) => { return req("post", "/api/department/uploadSeal", params) };


export const findInverseDetails = (params) => { return req("get", "/api/inverseDetail/findInverseDetails", params) };

export const findFinalBillData = (params) => { return req("get", "/api/finalMonthBillData/findFinalBillData", params) };

export const findInverseProcess = (params) => { return req("get", "/api/inverseProcess/findInverseProcess", params) };

export const exportInverseDetails = (params) => { return downLoadReq("get", "/api/inverseDetail/exportInverseDetails", params) };

export const exportFinalBillData = (params) => { return downLoadReq("get", "/api/finalMonthBillData/exportFinalBillData", params) };

export const exportInverseProcess = (params) => { return downLoadReq("get", "/api/inverseProcess/exportInverseProcess", params) };


export const inverseBill = (params) => { return req('post',"/api/newMonthBillData/inverseBill", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js